( function( $ ) {
    var headerHeight = $('#header').height();

    window.stickybits('.order-review-container', {
        stickyBitStickyOffset: headerHeight,
        useStickyClasses: true
    });

    window.stickybits('.sticky', {
        stickyBitStickyOffset: 112,
        useStickyClasses: true
    });

    // Disabled for ticket: MM-4637
    // var shopSidebarStickybits = window.stickybits('.shop-category__sidebar__inner', {
    //     stickyBitStickyOffset: headerHeight + $('.shop-category__category-navbar').outerHeight() + 17,
    //     useStickyClasses: true
    // });
    //
    // $(window).on('resize', function(){
    //     shopSidebarStickybits.update({ stickyBitStickyOffset: headerHeight + $('.shop-category__category-navbar').outerHeight() + 17 });
    // });

})(jQuery);